import React from "react";

export const Contacts = () => {
  return (
    <>
      <p>
        This is a real money gambling app. Please gamble responsibly and only
        bet what you can afford. For gambling addiction help and support, please
        contact Gamble Aware at:
      </p>
      <p>
        <i className="fa fa-phone-square" aria-hidden="true"></i> For UK: 0808
        8020 133
      </p>
      <p>
        <i className="fa fa-phone-square" aria-hidden="true"></i> For Ireland:
        1800 753 753
      </p>
      <p>or visit website:</p>
      <p>
        <i className="fa fa-external-link" aria-hidden="true"></i> For UK:{" "}
        <a href="https://www.begambleaware.org/" target="_blank">
          https://www.begambleaware.org/
        </a>
      </p>
      <p style={{ marginBottom: "36px" }}>
        <i className="fa fa-external-link" aria-hidden="true"></i> For Ireland:{" "}
        <a href="https://www.gambleaware.ie/" target="_blank">
          https://www.gambleaware.ie/
        </a>
      </p>
    </>
  );
};

export const Contacts_1500_300_IE = () => {
  return (
    <>
      <p>
        This is a real money gambling app. Please gamble responsibly and only
        bet what you can afford. For gambling addiction help and support, please
        contact Gamble Aware at:
      </p>
      <p>
        <i className="fa fa-phone-square" aria-hidden="true"></i> For Ireland:
        1800 753 753
      </p>
      <p>or visit website:</p>
      <p style={{ marginBottom: "36px" }}>
        <i className="fa fa-external-link" aria-hidden="true"></i> For Ireland:{" "}
        <a href="https://www.gambleaware.ie/" target="_blank">
          https://www.gambleaware.ie/
        </a>
      </p>
    </>
  );
};

export const EmptyContacts = () => {
  return <></>;
};

export const Contacts_IE = () => {
  return (
    <>
      <p>
        This is a real money gambling app. Please gamble responsibly and only
        bet what you can afford. For gambling addiction help and support, please
        contact Gamble Aware at:
      </p>
      <p>
        <i className="fa fa-phone-square" aria-hidden="true"></i> For Ireland:
        1800 753 753
      </p>
      <p>or visit website:</p>
      <p style={{ marginBottom: "36px" }}>
        <i className="fa fa-external-link" aria-hidden="true"></i> For Ireland:{" "}
        <a href="https://www.gambleaware.ie/" target="_blank">
          https://www.gambleaware.ie/
        </a>
      </p>
    </>
  );
};

export default Contacts;
